export default function clickableRow(row) {
    row.addEventListener("click", (event) => {
        const link = row.querySelector("a");
        if (link && link.href && event.target !== link) {
            window.location.href = link.href;
        }
    });
}
